import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=06895c7b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=06895c7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06895c7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06895c7b')) {
      api.createRecord('06895c7b', component.options)
    } else {
      api.reload('06895c7b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=06895c7b&scoped=true&", function () {
      api.rerender('06895c7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ay15uLUk0K6d/JS/comp/SearchFilterTokens.vue"
export default component.exports